require.register("modules/m04/m04-activity/page-20/page-20", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page20 = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page20;

  
});

